import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import uuid from 'uuid/v4';
import styled from 'styled-components';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import jsonData from './DENNiS - Sample_modified.json';
import { pagination, toasterConfig } from "../../utils/constants";
import { getDocumentTypes } from "../../context/actions/document";
import { Input } from 'reactstrap';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { Treebeard } from 'react-treebeard';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useComponentVisible from '../../components/common/TreeBeard/useComponentVisible';
import decorators from "react-treebeard/dist/components/Decorators";
import defaultTheme from "react-treebeard/dist/themes/default";
import * as filters from '../../components/common/TreeBeard/filters';
import { saveUnlabeledPdfData } from '../../context/actions/document';
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './index.css'
import SaveUnlabeledData from '../UnlabeledDocumentDetail/DocumentView/saveModal/index';

import ToggleSwitchComponent from '../toggleSwitch';


var _ = require('lodash');

const MySwal = withReactContent(Swal);

const DennisFile = ({ modelData, totalDocRecords, draftJson, draftJsonFlag, updateDocumentViewData, fileData, nextDocFlag, markCompleted, onBgColorChange }) => {
    // console.log("render DennisFile")
    const history = useHistory();
    const [state, setState] = useState({})
    const [ITEMS, setITEMS] = useState([])
    const [value, setValue] = useState('');
    const [showAccordian, setShowAccordian] = useState(null);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [isDocumentTypeSelected, setIsDocumentTypeSelected] = useState(false);
    const [label, setLabel] = useState(null)
    const { refrence, isComponentVisible, setIsComponentVisible } = useComponentVisible(true);
    const [dropdownData, setDropdownData] = useState({});
    const [dropData, setDropData] = useState({ name: '', toggled: true, children: [] });
    const [cursor, setCursor] = useState(false);
    const [deletedItems, setDeletedItems] = useState([]);
    const dispatch = useDispatch();
    const [saveDisabled, setSaveDisabled] = useState(false);
    const [showModal, setShowModel] = useState(false);
    const [isAddButtonDisabled, setAddButtonDisabled] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [scrollPosition1, setScrollPosition1] = useState(0);
    const [draft, setDraft] = useState({})
    const [copyDraft, setCopyDraft] = useState({})
    const [classification, setClassification] = useState({})
    const [listName, setListName] = useState(null)
    const [loanNumber, setLoanNumber] = useState(null)
    const [selectedItems, setSelectedItems] = useState([]);
    const [classificationArray, setClassificationArray] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [originalJson, setOriginalJson] = useState(fileData.original_json);
    const [secondaryBgColor, setSecondaryBgColor] = useState('#fff');
    const [primaryBgColor, setPrimaryBgColor] = useState('#ccc');
    const [isButtonEnabled, setIsButtonEnabled] = useState(true)
    const [level2ChildrenArray, setLevel2ChildrenArray] = useState([])

    const divRef = useRef(null);
    const scrollContainerRef = useRef(null);

    const [timer, setTimer] = useState(new Date());

    useEffect(() => {
        // document.documentElement.style.setProperty('--inner-background', secondaryBgColor);
        onBgColorChange(secondaryBgColor);
    }, [secondaryBgColor, onBgColorChange]);

	useEffect(()=> {
		setTimer(new Date());
	},[])

    useEffect(()=> {
        if(Object.keys(modelData).length > 0){
            if(modelData.hasOwnProperty("classifications")){
                let newdata = { ...dropData, children: [] };
                newdata.children = modelData?.classifications;
                setDropData(newdata);
            }
            if(modelData?.primary_color){
                const primaryColor = modelData?.primary_color.startsWith('#') ? modelData.primary_color : `#${modelData.primary_color}`;
                setPrimaryBgColor(primaryColor)
                document.documentElement.style.setProperty('--inner-background', primaryColor)
            }
            if(modelData?.secondary_color){
                const secondaryColor = modelData?.secondary_color.startsWith('#') ? modelData.secondary_color : `#${modelData.secondary_color}`;
                setSecondaryBgColor(secondaryColor)
            }
        }else{
            setPrimaryBgColor('#ccc');
            document.documentElement.style.setProperty('--inner-background', '#ccc');
            setSecondaryBgColor('#fff');
        }
    },[modelData])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const restoreScrollPosition = () => {
        let itemScrollContainer = document.getElementById("draggable-listing_1");
        if (itemScrollContainer) {
            itemScrollContainer.scrollTo({
                top: scrollPosition1,
                left: 0,
                behavior: 'auto',
            });
        }
    };

    useLayoutEffect(() => {
        restoreScrollPosition();
    }, [restoreScrollPosition, scrollPosition1]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const restoreScrollPos = () => {
        scrollContainerRef.current.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: 'auto'
        })
    }

    useLayoutEffect(() => {
        restoreScrollPos()
    }, [restoreScrollPos, scrollPosition])

    const sendToDocViewData = (dataToSend, e) => {
        switch (e.detail) {
            case 1:
                const itemScrollContainer = document.getElementById("draggable-listing_1");
                if (itemScrollContainer) {
                    setScrollPosition1(itemScrollContainer.scrollTop)
                }
                updateDocumentViewData(dataToSend);
                break;
            case 2:
                if (listName !== "" && listName !== null) {
                    setState(stateItem => ({ ...stateItem, [listName]: [...stateItem[listName], ...[dataToSend]] }))
                    setDeletedItems([...deletedItems, dataToSend]);
                    ITEMS.splice(ITEMS.indexOf(dataToSend), 1);
                    setITEMS([...ITEMS]);
                } else {
                    toast.error("Please Add a label first to start adding pages.", toasterConfig);
                }
                break;
            default:
                console.log("Please Add a label first to start adding pages.");
        }
    };

    const sendToDocData = (data) => {
        const scrollPosition = scrollContainerRef.current.scrollTop;
        setScrollPosition(scrollPosition)
        updateDocumentViewData(data);
    }

    const base64ToBinary = (base64) => {
        // Convert base64 to binary
        const binaryData = atob(base64);
        const arrayBuffer = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
            arrayBuffer[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer]);
        return URL.createObjectURL(blob)
    }

    const blobToBase64 = async (blobUrl) => {
        const response = await fetch(blobUrl);
        const blobData = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64String = reader.result.split(',')[1];
                // console.log(base64String);
                resolve(base64String);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blobData);
        });
    }

    useEffect(() => {
        _getDocumentTypes()
        // transform data and prefill the labels
        _prefillItems()
        // transform data and create backup labels for prefill labels
        _setBackupData()
        const handleWindowLoad = () => {
            divRef.current.click();
        };

        window.onload = handleWindowLoad;

        return () => {
            window.onload = null;
        };
    }, [])

    useEffect(() => {
        if (divRef.current) {
            divRef.current.click();
        }
    }, [JSON.stringify(state)]);

    useEffect(() => {
        if (!Object.keys(state).length) {
            setSaveDisabled(true)
        } else {
            setSaveDisabled(false)
        }

    }, [JSON.stringify(state)])

    useLayoutEffect(() => {
        scrollContainerRef.current.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: 'auto'
        })
    }, [JSON.stringify(state)])

    useEffect(() => {
        const getLevel2Children = (arr) => {
            let level2Children = [];

            arr.forEach(item => {
                if (item.children) {
                    item.children.forEach(level1Child => {
                        if (level1Child.children) {
                            level1Child.children.forEach(level2Child => {
                                level2Children.push({
                                    id: level2Child.id,
                                    name: level2Child.name,
                                    level: level2Child.level
                                });
                            });
                        }
                    });
                }
            });

            return level2Children;
        };

        const level2ChildrenArray = getLevel2Children(dropData.children || []);
        setLevel2ChildrenArray(level2ChildrenArray)

    }, [dropData])

    const _prefillItems = async () => {
        let transformedData = {}
        let transformItemData = []
        let originalJson = {}
        if (fileData?.draft_json && Object.keys(fileData.draft_json).length) {
            originalJson = { ...fileData.draft_json }
        } else {
            originalJson = { ...fileData.original_json }
        }
        originalJson.documents.forEach((item) => {
            if (item?.classification != null && item?.classification !== '') {
                const classification = item.classification + "_" + Math.random();
                if (!(classification in transformedData)) {
                    transformedData[classification] = [];
                    // setClassificationArray(prevArray => [...prevArray, { classification, confidence: item.confidence, name: item.name }]);
                }

                item.pages.forEach((page) => {
                    const transformedPage = {
                        ...page,
                        confidence: item.confidence,
                        name: item.name,
                        passed: item.passed,
                        base64_thumbnail: base64ToBinary(page.base64_thumbnail),
                        ai_properties: {
                            ...page.ai_properties,
                        },
                        id: uuid(),
                    };
                    transformedData[classification].push(transformedPage);
                });
            } else {
                setClassification(item?.classification)
                // console.log("❤️❤️", item )
                item.pages.forEach((page) => {
                    const transformedPage = {
                        ...page,
                        // confidence: item.confidence,
                        // name: item.name,
                        // passed: item.passed,
                        base64_thumbnail: base64ToBinary(page.base64_thumbnail),
                        ai_properties: {
                            ...page.ai_properties,
                        },
                        id: uuid(),
                    };
                    transformItemData.push(transformedPage)
                });
            }
        });
        setITEMS(prevItems => [...prevItems, ...transformItemData]);
        setState(transformedData)
        // console.log(transformedData)
    }

    const _setBackupData = async () => {
        const finalData = [];

        for (const key in state) {
            if (Object.hasOwnProperty.call(state, key)) {
                const item = state[key];
                item.forEach((page, index) => {
                    finalData.push({
                        page_number: page.page_number,
                        rotation: page.rotation,
                        base64_thumbnail: page.base64_thumbnail,
                        ai_properties: {
                            ...page.ai_properties,
                        },
                        id: page.id
                    });
                });
            }
        }

        setDeletedItems(...deletedItems, finalData);
    }

    const _getDocumentTypes = async () => {
        dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted: true }, (res) => {
                let newdata = { ...dropData, children: res?.tree };
                setDropData(newdata);
            })
        )
    }

    const onMouseEnterHandler = () => {
        if (value) {
            const inputBlcElem = document.getElementById('inputBlc');
            const inputBlcElemLeftPosition = document.getElementById('inputBlc').getBoundingClientRect().left;
            const inputBlcElemTopPosition = document.getElementById('inputBlc').getBoundingClientRect().top;
            const labelDropdownElem = document.getElementById('labelTooltip');


            labelDropdownElem.style.left = inputBlcElemLeftPosition + 'px';
            labelDropdownElem.style.top = inputBlcElemTopPosition + 'px';

            setTooltipVisible(true);

            labelDropdownElem.style.marginTop = - labelDropdownElem.clientHeight + 'px';

        }

    }
    const onMouseLeaveHandler = () => {
        if (value) {
            setTooltipVisible(false);
        }
    }

    const onClick = (value) => {
        setIsComponentVisible(true)
        const filter = value?.trim();
        // decorators.Header = CustomHeader
        defaultTheme.tree.node.activeLink.background = 'red';
        if (!filter) {
            setDropdownData(dropData);
        } else {
            let filtered = filters.filterTree(dropData, filter);
            filtered = filters.expandFilteredNodes(filtered, filter);
            setDropdownData(filtered);
        }
    }

    const onFilterMouseUp = ({ target: { value } }) => {
        const filter = value.trim();
        if (!filter) {
            return setDropdownData(dropData);
        }
        let filtered = filters.filterTree(dropData, filter);
        filtered = filters.expandFilteredNodes(filtered, filter);

        setDropdownData(filtered);
    }

    const deleteDocumentType = () => {
        setIsDocumentTypeSelected(false);
        setValue('');
        setLabel(null)
    }

    // const CustomHeader = (props) => {
    //     return (
    //         <div style={{
    //             fontWeight: `${props.node.children?.length ? 'bold' : ''}`,
    //             fontSize: 12
    //         }}
    //             className={`${props.node.children?.length ? 'sd-header' : 'sd-childs'}`}>
    //             {props.node.name}
    //         </div>
    //     );
    // }

    const onToggle = (node, toggled) => {
        setIsComponentVisible(true)
        if (!node.children) {

            setIsDocumentTypeSelected(true)
            setLabel(node._id);

            //   console.log('node._id', node._id)
            let selectOptionPrevs = value;
            setValue(node.name)
            setIsComponentVisible(false)
        }
        if (cursor) {
            cursor.active = false;
        }
        node.active = true;
        if (!node.name) {
            node.toggled = true;
        }
        else if (node.children) {
            node.toggled = toggled;
        }
        setCursor(node);
        setDropdownData(Object.assign({}, dropdownData))
        if (node && (node.item_level === 2 || node.level === 2)) {
            setAddButtonDisabled(false);
        } else {
            setAddButtonDisabled(true);
        }
    }


    // a little function to help us with reordering the result
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };
    /**
     * Moves an item from one list to another list.
     */
    const copy = (source, destination, droppableSource, droppableDestination) => {
        // console.log('==> dest', destination);

        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const item = sourceClone[droppableSource.index];

        destClone.splice(droppableDestination.index, 0, { ...item, id: uuid() });
        return destClone;
    };

    const copyMultiple = (source, destination, droppableSource, droppableDestination) => {

        const item = source.filter(item => selectedItems.includes(item.id)).sort((a, b) => b.page_number - a.page_number)
        const sourceClone = Array.from(item);
        const destClone = Array.from(destination);
        sourceClone.forEach((item) => {
            destClone.splice(droppableDestination.index, 0, { ...item, id: uuid() });
        })
        // destClone.sort((a, b) => a.page_number - b.page_number)
        return destClone;
    };

    const move = (source, destination, droppableSource, droppableDestination, state) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = { ...state };
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;

        return result;
    };

    const Content = styled.div`
`;

    const Item = styled.div`
    display: flex;
    user-select: none;
    padding: 0.5rem;
    margin: 0 0 0.5rem 0;
    align-items: flex-start;
    align-content: flex-start;
    line-height: 1.5;
    border-radius: 3px;
    background: ${primaryBgColor};
    border: 1px ${props => (props.isDragging ? 'dashed #4099ff' : 'solid #ddd')};
`;

    const Clone = styled(Item)`
    + div {
        display: none !important;
    }
`;

    const Handle = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    user-select: none;
    margin: -0.5rem 0.5rem -0.5rem -0.5rem;
    padding: 0.5rem;
    line-height: 1.5;
    border-radius: 3px 0 0 3px;
    background: ${secondaryBgColor};
    border-right: 1px solid #ddd;
    color: #000;
`;

    const List = styled.div`
    border: 1px
        ${props => (props.isDraggingOver ? 'dashed #000' : 'solid #ddd')};
    background: ${secondaryBgColor};
    padding: 0.5rem 0.5rem 0;
    border-radius: 3px;
    flex: 0 0 150px;
    font-family: sans-serif;
`;

    const Kiosk = styled(List)`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 200px;
`;

    const Container = styled(List)`
    margin: 0.5rem 0.5rem 1.5rem;
    background: ${primaryBgColor};
`;

    const Notice = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    padding: 0.5rem;
    margin: 0 0.5rem 0.5rem;
    border: 1px solid transparent;
    line-height: 1.5;
    color: #aaa;
`;

    const Button = styled.button`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin: 0.5rem;
    padding: 0.5rem;
    color: #000;
    border: 1px solid #ddd;
    background: ${secondaryBgColor};
    border-radius: 3px;
    font-size: 1rem;
    cursor: pointer;

    /* Style for the disabled button */
    &.disabled {
        background: #ccc; /* Change the background color */
        cursor: not-allowed; /* Change the cursor style */
    }
`;

    const ButtonText = styled.div`
    margin: 0 1rem;
`;

    const onDragEnd = (result) => {
        const { source, destination } = result;

        // console.log('==> result', result);

        if (!Object.keys(state).length) {
            toast.error("Please Add a label first to start adding pages.", toasterConfig);
            setSelectedItems([]);
            return;
        }

        // dropped outside the list
        if (!destination) {
            return;
        }
        switch (source.droppableId) {
            case destination.droppableId:
                setState({
                    ...state,
                    [destination.droppableId]: reorder(
                        state[source.droppableId],
                        source.index,
                        destination.index
                    )
                });
                break;
            case 'ITEMS':
                let dragIdIsMatch = selectedItems.includes(result.draggableId);
                if (selectedItems.length > 1 && dragIdIsMatch) {
                    const updateDestination = copyMultiple(
                        ITEMS,
                        state[destination.droppableId],
                        source,
                        destination
                    )
                    setState({
                        ...state,
                        [destination.droppableId]: updateDestination
                    });
                    setDeletedItems([...deletedItems, ...ITEMS.filter(item => selectedItems.includes(item.id))]);
                    setITEMS(ITEMS.filter(item => !selectedItems.includes(item.id)));
                    setSelectedItems([])
                } else {
                    setSelectedItems([])
                    setState({
                        ...state,
                        [destination.droppableId]: copy(
                            ITEMS,
                            state[destination.droppableId],
                            source,
                            destination
                        )
                    });
                    // console.log(source.index);
                    setDeletedItems([...deletedItems, ITEMS[source.index]]);
                    ITEMS.splice(source.index, 1);
                    setITEMS([...ITEMS]);
                }
                break;
            default:
                setState(
                    move(
                        state[source.droppableId],
                        state[destination.droppableId],
                        source,
                        destination,
                        state
                    )
                );
                break;
        }

        if (destination) {
            const scrollPosition = scrollContainerRef.current.scrollTop;
            setScrollPosition(scrollPosition)
        }
        const itemScrollContainer = document.getElementById("draggable-listing_1");
        if (itemScrollContainer) {
            setScrollPosition1(itemScrollContainer.scrollTop)
        }
        // console.log(state)
    };

    const addList = () => {
        if (value) {
            let newlist = value + "_" + Math.random()
            setListName(newlist)
            setState({ ...state, [newlist]: [] });
            // setShowAccordian(Object.keys({ ...state, [newlist]: [] }).length - 1)
            setShowAccordian(newlist)
            // console.log({ ...state, [newlist]: [] })
            // setAddButtonDisabled(true);
            // deleteDocumentType()

            // let parentElement = document.getElementById("innerDiv")
            // parentElement.find('*:not(:last-child)').removeClass('show');
        }
    };

    const restoreItem = (item, list, event) => {
        event.stopPropagation();
        const restoredItem = state[list].filter(e => (JSON.stringify(e) === JSON.stringify(item)))
        delete restoredItem[0].confidence;
        delete restoredItem[0].passed;
        setITEMS([...ITEMS, restoredItem[0]].sort((a, b) => a.page_number - b.page_number));
        const newData = {};
        for (const key in state) {
            if (state.hasOwnProperty(key)) {
                newData[key] = state[key].filter((item) => item.id !== restoredItem[0].id);
            }
        }
        setState(newData)
        let updatedDeletedItems = deletedItems.filter(e => (JSON.stringify(e) !== JSON.stringify(item)))
        setDeletedItems(updatedDeletedItems);
    };

    const restoreMultipleItem = (listName) => {
        setListName(null)

        const keysBefore = Object.keys(state); // capture state before deletion
        const deletedKey = listName;
    
        const cleanedItems = state[listName].map(item => {
            delete item.confidence;
            delete item.passed;
            return item;
        });
    
        setITEMS([...ITEMS, ...cleanedItems].sort((a, b) => a.page_number - b.page_number));
    
        const newDeletedData = deletedItems.filter(item1 =>
            !state[listName].some(item2 => JSON.stringify(item1) === JSON.stringify(item2))
        );
    
        delete state[listName];
        const keysAfter = Object.keys(state); // after deletion
    
        // If only 2 were present, and now 1 is left
        if (
            keysBefore.length === 2
        ) {
            const remainingKey = keysAfter[0];
            setShowAccordian(remainingKey);
            setListName(remainingKey)
        }
    
        // If deleted one was open, close the accordion
        // if (showAccordian === deletedKey) {
        //     setShowAccordian(null);
        // }
    
        setState({ ...state }); // use spread to trigger re-render
        setDeletedItems(newDeletedData);
    }

    const makeDoc = () => {
        if (Object.keys(state).length) {
            setShowModel(false)
            dispatch({ type: "ISLOADING", data: true });
            const filteredData = Object.fromEntries(
                Object.entries(state).filter(([key, value]) => Array.isArray(value) && value.length > 0)
            );
            const transformedData = Object.entries(filteredData).map(([documentName, pages]) => ({
                classification: documentName.split('_')[0],
                confidence: pages[0]?.confidence
                    ? pages[0]?.confidence
                    // ? parseFloat(pages[0]?.confidence * 100).toFixed(1).replace(/\.0+$/, '')
                    : "",
                pages: pages.map(page => ({
                    base64_thumbnail: page.base64_thumbnail,
                    page_number: page.page_number,
                    rotation: page.rotation,
                    ai_properties: page.ai_properties
                }))
            }));

            let totalNumberOfPages = 0;
            transformedData.forEach(document => {
                totalNumberOfPages += document.pages.length;
            });
            let modifiedJson = {
                "filename": fileData.original_json.filename,
                "content_type": "application/pdf",
                "size": 416427,
                "loan_number": loanNumber,
                "number_of_pages": totalNumberOfPages,
                "documents": transformedData
            }
            if(originalJson.model_name){
                modifiedJson['model_name'] = originalJson.model_name
            }
            if(originalJson.model_identifier){
                modifiedJson['model_identifier'] = originalJson.model_identifier
            }
            // console.log(modifiedJson)

            dispatch(saveUnlabeledPdfData({ docId: fileData._id, json: modifiedJson, draft: copyDraft, validationCompletionTime: Math.round((new Date() - timer) / 1000) }, (result) => {
                if (result?.data) {
                    setTimer(new Date());
                    // console.log(result)
                    dispatch({ type: "ISLOADING", data: false });
                    setLoanNumber(null)
                    // setState({})
                    // setITEMS(fileData?.original_json?.documents[0].pages)
                    toast.success(result?.message, toasterConfig);
                    // history.push("/documents");
                    if (totalDocRecords == 1) {
                        history.push("/documents");
                    } else {
                        nextDocFlag(fileData._id);
                    }

                } else {

                    dispatch({ type: "ISLOADING", data: false });
                    toast.error(result?.message, toasterConfig);

                }
            }))
        }
    };

    const processLayoutEffect = async () => {
        const filteredData = Object.fromEntries(
            Object.entries(state).filter(([key, value]) => Array.isArray(value) && value.length > 0)
        );
        if (Object.keys(filteredData).length || ITEMS.length) {
            let transformedData = await Promise.all(Object.entries(filteredData).map(async ([documentName, pages]) => {
                return {
                    classification: documentName.split('_')[0],
                    ...pages[0].name !== undefined && { name: pages[0].name },
                    ...pages[0]?.confidence !== undefined && { confidence: pages[0].confidence },
                    ...pages[0]?.passed !== undefined && { passed: pages[0].passed },
                    pages: await Promise.all(pages.map(async page => ({
                        page_number: page.page_number,
                        rotation: page.rotation,
                        base64_thumbnail: await blobToBase64(page.base64_thumbnail),
                        ai_properties: page.ai_properties
                    })))
                };
            }));

            let nameCheck = null, confidenceCheck = null, passedCheck = null
            const modifiedPages = await Promise.all(ITEMS.map(async page => {
                if (page?.name !== null) {
                    nameCheck = true;
                }
                if ('name' in page) {
                    nameCheck = false;
                }
                if (page?.confidence !== null) {
                    confidenceCheck = true;
                }
                if ('confidence' in page) {
                    nameCheck = false;
                }
                if(page?.passed !== null) {
                    passedCheck = true;
                }
                if ('passed' in page) {
                    nameCheck = false;
                }
                return {
                    page_number: page.page_number,
                    rotation: page.rotation,
                    base64_thumbnail: await blobToBase64(page.base64_thumbnail),
                    ai_properties: page.ai_properties
                };
            }));

            if (modifiedPages.length) {
                let remainItems = {
                    ...(nameCheck == false && { name: null }),
                    ...(confidenceCheck == false && { confidence: 0 }),
                    ...(passedCheck == false && { passed: false }),
                    "classification": '',
                    "pages": modifiedPages
                }

                fileData[fileData.draft_json && Object.keys(fileData.draft_json).length > 0? "draft_json" : "original_json"].documents.forEach(item => {
                    if(item?.classification != null && item?.classification === ''){
                        // console.log("❤️❤️",item)
                        if ('name' in item) {
                            remainItems['name'] = item?.name;
                        }
                        if ('confidence' in item) {
                            remainItems['confidence'] = item?.confidence;
                        }
                        if ('passed' in item) {
                            remainItems['passed'] = item?.passed;
                        }
                    }
                })

                transformedData = [...transformedData, remainItems]
            }
            makeDraft(transformedData)
        } else {
            draftJsonFlag(false)
            draftJson({})
        }
    }

    const makeDraft = (transformedData) => {
        let totalNumberOfPages = 0;
        transformedData.forEach(document => {
            totalNumberOfPages += document.pages.length;
        });
        let _draftJson = {
            "filename": fileData.original_json.filename,
            "content_type": "application/pdf",
            "size": fileData.original_json.size,
            "image_to_pdf_base64": fileData.original_json.image_to_pdf_base64,
            "number_of_pages": totalNumberOfPages,
            "documents": transformedData
        }
        if (fileData.original_json.loan_number == null) {
            delete fileData.original_json.loan_number
        } else if (fileData.original_json.loan_number) {
            _draftJson['loan_number'] = loanNumber
        }

        if(originalJson.model_name){
            _draftJson['model_name'] = originalJson.model_name
        }
        if(originalJson.model_identifier){
            _draftJson['model_identifier'] = originalJson.model_identifier
        }

        // console.log("❤️❤️",_draftJson)
        setCopyDraft(_draftJson)
        // console.log("❤️❤️",fileData.original_json)
        // console.log("❤️❤️",fileData.draft_json)
        // const differences = findDifferences(_draftJson, fileData.draft_json);
        // console.log("❤️❤️ Differences:", differences);
        if (fileData?.draft_json && Object.keys(fileData.draft_json).length) {
            if (_.isEqual(_draftJson, fileData.draft_json)) {
                draftJsonFlag(false)
            } else {
                draftJsonFlag(true)
            }
        } else if (_.isEqual(_draftJson, fileData.original_json)) {
            draftJsonFlag(false)
        } else {
            draftJsonFlag(true)
            setDraft(_draftJson)
            draftJson(_draftJson)
        }
    }

    // const findDifferences = (obj1, obj2) => {
    //     const changes = (obj1, obj2) => {
    //         return _.transform(obj1, (result, value, key) => {
    //             if (!_.isEqual(value, obj2[key])) {
    //                 result[key] = {
    //                     value1: value,
    //                     value2: obj2[key]
    //                 };
    //             }
    //         });
    //     };
    //     return changes(obj1, obj2);
    // };

    useLayoutEffect(() => {
        processLayoutEffect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(state), ITEMS])

    const popup = () => {

        const filteredData = Object.fromEntries(
            Object.entries(state).filter(([key, value]) => Array.isArray(value) && value.length > 0)
        );
        if (Object.keys(filteredData).length) {
            // setState(filteredData)
            if (!showModal) {
                setShowModel(true)
            }
        } else {
            toast.warning("Please add pages in the document label.", toasterConfig);
        }
    }

    const toggleClass = (element, list) => {

        setListName(list)
        const headElement = element.target.closest('.head');
        const isOpen = headElement.classList.contains("show");
    
        // Toggling the class manually
        headElement.classList.toggle("show");
    
        if (isOpen) {
            // It was open, and user is closing it
            setShowAccordian(null);
        } else {
            // It was closed, and user is opening it
            setShowAccordian(list);
            // setLastOpenAccordion(list); // Optional: if you're tracking this for delete logic
        }
    };
    const [clickCount, setClickCount] = useState(0);
    const [firstIndex, setFirstIndex] = useState(null);

    const onSelect = (event, item) => {
        if (event.ctrlKey) {
            if (event.button === 0) {
                if (selectedItems.includes(item)) {
                    setSelectedItems(selectedItems.filter(selectedItem => selectedItem !== item));
                } else {
                    setSelectedItems([...selectedItems, item]);
                }
                setClickCount(0)
                setFirstIndex(null)
            }
        }
        if (event.shiftKey) {
            if (event.button === 0) {
                let secondIndex = null
                setClickCount(clickCount + 1);
                if (clickCount + 1 === 1) {
                    setFirstIndex(ITEMS.findIndex(i => item === i.id))
                }
                if (clickCount + 1 === 2) {
                    secondIndex = ITEMS.findIndex(i => item === i.id)
                }
                if (selectedItems.includes(item)) {
                    setSelectedItems(selectedItems.filter(selectedItem => selectedItem !== item));
                } else {
                    setSelectedItems([...selectedItems, item]);
                }

                let updatedSelectedItems = [...selectedItems];
                if ((firstIndex >= 0 && secondIndex >= 0) && (firstIndex < secondIndex)) {
                    for (let index = firstIndex; index <= secondIndex; index++) {
                        // if (selectedItems.includes(ITEMS[index].id)) {
                        //     updatedSelectedItems = updatedSelectedItems.filter(selectedItem => selectedItem !== ITEMS[index].id);
                        // } else {
                        updatedSelectedItems = [...updatedSelectedItems, ITEMS[index].id];
                        // }
                    }
                    setSelectedItems(Array.from(new Set(updatedSelectedItems)));
                    setClickCount(0)
                    setFirstIndex(null)
                }
                if ((firstIndex >= 0 && secondIndex >= 0) && (firstIndex > secondIndex)) {
                    for (let index = firstIndex; index >= secondIndex; index--) {
                        // if (selectedItems.includes(ITEMS[index].id)) {
                        //     updatedSelectedItems = updatedSelectedItems.filter(selectedItem => selectedItem !== ITEMS[index].id);
                        // } else {
                        updatedSelectedItems = [...updatedSelectedItems, ITEMS[index].id];
                        // }
                    }
                    setSelectedItems(Array.from(new Set(updatedSelectedItems)));
                    setClickCount(0)
                    setFirstIndex(null)
                }
            }
        }
    };


    const customTheme = {
        ...defaultTheme,
        tree: {
          ...defaultTheme.tree,
          node: {
            ...defaultTheme.tree.node,
            activeLink: {
              background: '#f0f0f0' // Changed from 'red' to be less aggressive
            }
          }
        }
      };

    const isLeafNode = (node) => node.level == 2 || node.item_level == 2;

    let nodeIndex = 0;
    let backgroundColor = '#f3f2ee';

    const CustomHeader = (props) => {

        if (isLeafNode(props.node)) {
          if(nodeIndex == 0){
           backgroundColor = '#f3f2ee';
           nodeIndex = 1;
          }else{
            backgroundColor = '#ffffff';
            nodeIndex = 0;
          }
        //   if(props.node._id == typeSelected){
        //     backgroundColor= '';
        //   }
          return (
            <div
              style={{
                ...props.style,
                backgroundColor,
                width: "100%",
                fontSize: 12,
                fontWeight: 'normal',
                borderRadius: '4px'
              }}
              className={` ${
                !props.node.children
                // (props.node._id == typeSelected ? "active" : "")
              } ${props.node.children?.length ? "sd-header" : "sd-childs"}`}
            >
              {props.node.name} {props.node.count > 0 ? `(${props.node.count})` : ""}
            </div>
          );
        }

        // For parent nodes
        return (
          <div
            // style={{
            //   ...props.style,
            //   padding: '4px 8px',
            //   fontSize: 12,
            //   fontWeight: 'bold',
            //   backgroundColor: 'transparent'
            // }}
            className={` ${
              !props.node.children
            //   (props.node._id == typeSelected ? "active" : "")
            } ${props.node.children?.length ? "sd-header" : "sd-childs"}`}
          >
            {props.node.name} {props.node.count > 0 ? `(${props.node.count})` : ""}
          </div>
        );
      };



    const customDecorators = {
        ...decorators,
        Header: CustomHeader
    };



    /*  const markCompleted = () => {
          MySwal.fire({
              title: "Mark as Complete",
              text: "Are you sure you want to Mark this complete?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
          }).then((result)=> {
              if(result.isConfirmed){
                  dispatch(updateCompleteStatus({docId: fileData?._id,version:0}, (res)=> {
              	
                  }))
              }
          })
      } */

    // useEffect(() => {
    //     console.log("useEffect", selectedItems)
    // }, [selectedItems])



    useEffect(()=> {
        let ButtonEnabled = level2ChildrenArray?.some(child => 
            child.name === value
        );
        setIsButtonEnabled(ButtonEnabled)
    }, [value])


    return (
        <>
            {/* <div ref={divRef}> */}
            <div ref={divRef} className='head'>
                <div className='dropdown-cell'>
                    <div ref={refrence} className="label-dropdown-blc position-relative">
                        <div className="dropdown-input" id="inputBlc"
                            onMouseEnter={onMouseEnterHandler}
                            onMouseLeave={onMouseLeaveHandler}>
                            <Input
                                className="form-control"
                                value={value}
                                onClick={(e) => { onClick(e.target.value) }}
                                onChange={(e) => { setValue(e.target.value) }}
                                onKeyUp={onFilterMouseUp.bind(this)}
                                onDoubleClick={isButtonEnabled ? addList : null}
                                placeholder="Select File Label"
                                type="text"
                                disabled={fileData?.complete || fileData?.reviewLabeled}

                            />
                            {isDocumentTypeSelected &&
                                <Button color="link" className='close-btn position-absolute p-0' onClick={() => deleteDocumentType()}>
                                    <FontAwesomeIcon icon={faClose} />
                                </Button>
                            }
                            {
                                value ? <div
                                    className={`label-tooltip position-fixed ${tooltipVisible ? 'active' : ''}`}
                                    id="labelTooltip">
                                    {value}
                                </div> : ''
                            }

                        </div>
                        {dropdownData?.children?.length !== 0 && isComponentVisible ? <Treebeard data={dropdownData} onToggle={onToggle} decorators={customDecorators} defaultTheme={customTheme} /> : null}
                    </div>
                </div>
                <Button disabled={isAddButtonDisabled || dropdownData?.children?.length === 0 || value.trim() === "" || fileData?.complete || fileData?.reviewLabeled || !isButtonEnabled} onClick={() => { addList() }} className={`add-list-btn ${isAddButtonDisabled || !isButtonEnabled || dropdownData?.children?.length === 0 || value.trim() === "" ? 'disabled' : ''}`}>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path
                            fill="currentColor"
                            d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                        />
                    </svg>
                    {/* <ButtonText className='lbl'>Add</ButtonText> */}
                </Button>
                <div class="loan-identifier">
                    <strong> Loan Folder Identifier</strong>
                    <Input disabled={fileData?.complete || fileData?.reviewLabeled} className="form-control" type="text" onChange={(e) => setLoanNumber(e.target.value)} />

                </div>

                <div className='mark-complete-outer-button mark-complete-action-btn'>

                    <Button onClick={() => { popup() }} className=  {`custom-disabled ${saveDisabled || fileData?.complete || fileData?.reviewLabeled || toggle ? 'disabled custom-gray-bg' : 'custom-green-bg'}`} disabled={saveDisabled || fileData?.complete || fileData?.reviewLabeled || toggle}>
                        <ButtonText className='lbl'>Submit for Processing</ButtonText>
                    </Button>
                    <Button className={`save-btn btn btn-success customsave-btn ${fileData?.complete || fileData?.reviewLabeled ? 'disabled custom-gray-bg' : toggle ? 'custom-green-bg': 'custom-gray-bg'}`} onClick={() => { markCompleted(fileData?._id, 0) }} disabled={!toggle || fileData?.complete || fileData?.reviewLabeled}>
                        <ButtonText className='lbl'> Mark Complete  </ButtonText>


                    </Button>



                    {/* Toggle Switch */}

                    <div className='toggle-switch'>
                        <ToggleSwitchComponent setToggle={(val) => setToggle(val)}  isDisabled={fileData?.complete || fileData?.reviewLabeled}/>
                    </div>





                </div>

                {originalJson && originalJson?.model_name != null && originalJson.hasOwnProperty("model_name") ? <div class="loan-identifier">
                    <strong style={{ fontSize: '20px' , color: '#417e9a' }}> {originalJson?.model_name.toUpperCase()} </strong>
                </div>: null}




            </div>

            <DragDropContext onDragEnd={(e) => { onDragEnd(e) }}>
                <div className='draggable-data-wrapper d-flex'>
                    <Content className='draggable-listing2'>

                        <div ref={scrollContainerRef} className='inner' id='innerDiv' >
                            {Object.keys(state).map((list, i) => {
                                // console.log('==> list', list);
                                return (
                                    <>
                                        <div className="draggable-items-block">
                                            <div
                                                className={`head d-flex align-items-center ${showAccordian === list ? "show" : ""
                                                    }`}
                                            >
                                                {/* <h4> {list.split('_')[0]}</h4> */}

                                                <Button
                                                    data-bs-toggle="collapse"
                                                    href={`#collapseExample${i}`}
                                                    onClick={(e) => {
                                                        toggleClass(e, list);
                                                        // setShowAccordian(list);
                                                    }}
                                                    role="button"
                                                    aria-expanded="false"
                                                    aria-controls="collapseExample"
                                                    color="link"
                                                    className="arrow-btn d-inline-flex align-items-center justify-content-center"
                                                    style={{ margin: "0" }}
                                                >
                                                    <span className="icon">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="24"
                                                            viewBox="0 -960 960 960"
                                                            width="24"
                                                        >
                                                            <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z" />
                                                        </svg>
                                                    </span>
                                                </Button>
                                                <a
                                                    data-bs-toggle="collapse"
                                                    className="label-name"
                                                    href={`#collapseExample${i}`}
                                                    onClick={(e) => {
                                                        toggleClass(e, list);
                                                        // setShowAccordian(list);
                                                    }}
                                                    role="button"
                                                    aria-expanded="false"
                                                    aria-controls="collapseExample"
                                                >
                                                    <span
                                                        class="text-truncate"
                                                        title={list.split("_")[0]}
                                                    >
                                                        {list.includes("IRS Form") ? list.split("IRS Form")[1].split("_")[0] : list.split("_")[0]}
                                                    </span>
                                                    {state[list][0]?.hasOwnProperty(
                                                        "confidence"
                                                    ) && state[list][0]?.confidence ? (
                                                        <span
                                                            className={`dataper ${(
                                                                state[list][0]?.passed
                                                                    ? state[list][0]?.passed
                                                                    : false
                                                            )
                                                                ? "green"
                                                                : "red"
                                                                }`}
                                                        >
                                                            {state[list][0]?.confidence
                                                                ? parseFloat(state[list][0]?.confidence * 100).toFixed(1).replace(/\.0+$/, '')
                                                                : 0}
                                                            %
                                                        </span>
                                                    ) : null}
                                                </a>
                                                <div className="right-col ms-auto">
                                                    <Button
                                                        disabled={fileData?.complete || fileData?.reviewLabeled}
                                                        color="link"
                                                        className="delete-list-btn"
                                                        onClick={() => {
                                                            restoreMultipleItem(list);
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="24px"
                                                            viewBox="0 0 24 24"
                                                            width="24px"
                                                            fill="#000000"
                                                        >
                                                            <path
                                                                d="M0 0h24v24H0z"
                                                                fill="none"
                                                            />
                                                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                                                        </svg>
                                                    </Button>
                                                </div>
                                            </div>
                                            <div
                                                className={`inner collapse ${showAccordian === list ? "show" : ""
                                                    }`}
                                                id={`collapseExample${i}`}
                                            >
                                                <Droppable
                                                    className="draggable-item-wrapper"
                                                    key={list}
                                                    droppableId={list}
                                                >
                                                    {(provided, snapshot) => (
                                                        <Container
                                                            innerRef={provided.innerRef}
                                                            isDraggingOver={
                                                                snapshot.isDraggingOver
                                                            }
                                                        >
                                                            {state[list].length
                                                                ? state[list].map(
                                                                    (item, index) => (
                                                                        <Draggable
                                                                            key={item.id}
                                                                            draggableId={item.id}
                                                                            index={index}
                                                                            isDragDisabled={fileData?.complete || fileData?.reviewLabeled}
                                                                        >
                                                                            {(
                                                                                provided,
                                                                                snapshot
                                                                            ) => (
                                                                                <Item
                                                                                    className="draggable-item"
                                                                                    innerRef={
                                                                                        provided.innerRef
                                                                                    }
                                                                                    {...provided.draggableProps}
                                                                                    isDragging={
                                                                                        snapshot.isDragging
                                                                                    }
                                                                                    style={
                                                                                        provided
                                                                                            .draggableProps
                                                                                            .style
                                                                                    }
                                                                                    onClick={(e) =>
                                                                                        sendToDocData(
                                                                                            item
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Handle
                                                                                        className="drag-btn"
                                                                                        {...provided.dragHandleProps}
                                                                                    >
                                                                                        <svg
                                                                                            width="24"
                                                                                            height="24"
                                                                                            viewBox="0 0 24 24"
                                                                                        >
                                                                                            <path
                                                                                                fill="currentColor"
                                                                                                d="M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z"
                                                                                            />
                                                                                        </svg>
                                                                                    </Handle>
                                                                                    <Button
                                                                                        disabled={fileData?.complete || fileData?.reviewLabeled}
                                                                                        color="link"
                                                                                        className="delete-btn"
                                                                                        onClick={(
                                                                                            event
                                                                                        ) => {
                                                                                            restoreItem(
                                                                                                item,
                                                                                                list,
                                                                                                event
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            height="24px"
                                                                                            viewBox="0 0 24 24"
                                                                                            width="24px"
                                                                                            fill="#000000"
                                                                                        >
                                                                                            <path
                                                                                                d="M0 0h24v24H0z"
                                                                                                fill="none"
                                                                                            />
                                                                                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                                                                                        </svg>
                                                                                    </Button>
                                                                                    {item.base64_thumbnail && (
                                                                                        <img
                                                                                            key={index}
                                                                                            src={
                                                                                                item.base64_thumbnail
                                                                                            }
                                                                                            alt={`${index}`}
                                                                                            
                                                                                        />
                                                                                    )}
                                                                                    <span className="lbl">
                                                                                        Page{" "}
                                                                                        {
                                                                                            item?.page_number
                                                                                        }
                                                                                    </span>
                                                                                </Item>
                                                                            )}
                                                                        </Draggable>
                                                                    )
                                                                )
                                                                : provided.placeholder && (
                                                                    <Notice>
                                                                        Drop items here
                                                                    </Notice>
                                                                )}
                                                            {provided.placeholder}
                                                        </Container>
                                                    )}
                                                </Droppable>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </Content>
                    <Droppable droppableId="ITEMS" isDropDisabled={true}>
                        {(provided, snapshot) => (
                            <Kiosk
                                id="draggable-listing_1"
                                className='draggable-listing1'
                                innerRef={provided.innerRef}
                                isDraggingOver={snapshot.isDraggingOver}>
                                {ITEMS && ITEMS.map((item, index) => (

                                    <Draggable
                                        key={item.id}
                                        draggableId={item.id}
                                        index={index}
                                        isDragDisabled={fileData?.complete || fileData?.reviewLabeled}
                                    >
                                        {(provided, snapshot) => (
                                            <React.Fragment>
                                                <Item onClick={e => { sendToDocViewData(item, e); onSelect(e, item.id) }} className='draggable-item'
                                                    innerRef={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    isDragging={snapshot.isDragging}
                                                    style={{
                                                        ...provided.draggableProps
                                                            .style,
                                                        backgroundColor: selectedItems.includes(item.id) ? 'lightblue' : secondaryBgColor
                                                    }}
                                                >
                                                    {item.base64_thumbnail && <img
                                                        key={index}
                                                        src={item.base64_thumbnail}
                                                        alt={`${index}`}
                                                    />}
                                                    Page {item.page_number}
                                                </Item>
                                                {snapshot.isDragging && (
                                                    <Clone> page_number {item.page_number}</Clone>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </Kiosk>
                        )}
                    </Droppable>
                </div>
            </DragDropContext>
            {/* </div> */}
            <SaveUnlabeledData items={ITEMS} showModal={showModal} setShowModel={(val) => setShowModel(val)} _makeDoc={() => { makeDoc() }} />
        </>
    );
}

export default DennisFile;